import React from 'react'
import ReactDOM from 'react-dom'
import ReactSVG from 'react-svg'
import * as Sentry from '@sentry/browser'

// Your top level component
import App from './App'

// Export your top level component as JSX (for static rendering)
export default App

// test, stage env: https://frontend-sentry.inten.to/settings/intento-frontend/projects/web-test/install/javascript-react/
// prod env: https://frontend-sentry.inten.to/settings/intento-frontend/projects/web-test/install/javascript-react/
Sentry.init({ dsn: global.SENTRY_FRONTEND_DSN })

const SWITCH_ON_DEMO = 'runTranslationDemo'

// Render your app
if (typeof document !== 'undefined') {
    if (window.location.search) {
        try {
            const params = window.location.search
                .slice(1)
                .split('&')
                .map(param => {
                    let key
                    let value
                    if (param.indexOf('=') === -1) {
                        key = param
                        value = true
                    } else {
                        let keyAndValue = param.split('=')
                            ;[key, value] = keyAndValue
                    }
                    return { key, value }
                })
            const selected = params.filter(p => p.key === SWITCH_ON_DEMO)
            if (selected.length > 0) {
                if (selected[0].value) {
                    sessionStorage.setItem(SWITCH_ON_DEMO, true)
                } else {
                    sessionStorage.removeItem(SWITCH_ON_DEMO)
                }
            }
            const unselected = params.filter(p => p.key !== SWITCH_ON_DEMO)
            const { pathname } = window.location
            let search = ''
            if (unselected.length > 0) {
                search = `?${unselected
                    .map(({ key, value }) => `${key}=${value}`)
                    .join('&')}`
            }
            window.history.replaceState(null, null, `${pathname}${search}`)
        } catch (err) {
            // maybe log something when in dev mode
        }
    } else {
        sessionStorage.removeItem(SWITCH_ON_DEMO)
    }

    const renderMethod = module.hot
        ? ReactDOM.render
        : ReactDOM.hydrate || ReactDOM.render

    renderMethod(
        <ReactSVG src="/icons.svg" className="svg-store" />,
        document.getElementById('icons')
    )

    const render = Comp => {
        renderMethod(<Comp />, document.getElementById('root'))
    }

    // Render
    render(App)
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/index.js